import { render, staticRenderFns } from "./NuevoContacto.vue?vue&type=template&id=0064de92&"
import script from "./NuevoContacto.vue?vue&type=script&lang=js&"
export * from "./NuevoContacto.vue?vue&type=script&lang=js&"
import style0 from "./NuevoContacto.vue?vue&type=style&index=0&id=0064de92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports